import { InteractionStatus } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Box, Button, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { PropsWithChildren } from 'react';
import { Redirect } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { useTitle } from 'shared/hooks';
import { AuthInProgress } from 'shared/providers';

function Div({ children }: PropsWithChildren<{}>) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: 15,
        height: 200,
      }}
    >
      {children}
    </Box>
  );
}

export function LoginPage() {
  useTitle('Wps pmt Login');
  const { enqueueSnackbar } = useSnackbar();
  const { instance, inProgress } = useMsal();

  const login = async () => {
    try {
      await instance.loginRedirect();
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };
  if (
    inProgress !== InteractionStatus.None &&
    inProgress !== InteractionStatus.Startup &&
    (inProgress === InteractionStatus.Login || inProgress === InteractionStatus.HandleRedirect)
  ) {
    return (
      <Div>
        <AuthInProgress />
      </Div>
    );
  }

  return (
    <>
      <AuthenticatedTemplate>
        <Redirect to={ROUTES.products} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Div>
          <Typography variant='h3'>Wps Pmt App</Typography>
          <Button size='large' variant='contained' color='primary' onClick={login}>
            Login
          </Button>
        </Div>
      </UnauthenticatedTemplate>
    </>
  );
}
